import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "oshow_big"
};
const _hoisted_2 = {
  class: "order_box"
};
const _hoisted_3 = {
  class: "goods_show"
};
const _hoisted_4 = {
  class: "goods_txt"
};
const _hoisted_5 = {
  class: "goods_info"
};
const _hoisted_6 = {
  class: "goods_buy"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar");
  const _component_router_link = _resolveComponent("router-link");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_van_nav_bar, {
    title: "退货详情",
    "left-arrow": "",
    onClickLeft: $setup.goBack,
    fixed: "",
    placeholder: ""
  }, null, 8, ["onClickLeft"]), _createElementVNode("div", _hoisted_1, [_cache[5] || (_cache[5] = _createElementVNode("div", {
    class: "title_s"
  }, "订单信息", -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("dl", null, [_cache[0] || (_cache[0] = _createElementVNode("dt", null, "退货号", -1)), _createElementVNode("dd", null, _toDisplayString($setup.orderInfo.oid), 1)]), _createElementVNode("dl", null, [_cache[1] || (_cache[1] = _createElementVNode("dt", null, "订货单号", -1)), _createElementVNode("dd", null, _toDisplayString($setup.orderInfo.ooid), 1)]), _createElementVNode("dl", null, [_cache[2] || (_cache[2] = _createElementVNode("dt", null, "退款金额", -1)), _createElementVNode("dd", null, "￥" + _toDisplayString($setup.orderInfo.price), 1)]), _createElementVNode("dl", null, [_cache[3] || (_cache[3] = _createElementVNode("dt", null, "订单状态", -1)), _createElementVNode("dd", null, _toDisplayString($setup.orderInfo.sname), 1)]), _createElementVNode("dl", null, [_cache[4] || (_cache[4] = _createElementVNode("dt", null, "退货时间", -1)), _createElementVNode("dd", null, _toDisplayString($setup.orderInfo.uptime), 1)])]), _cache[6] || (_cache[6] = _createElementVNode("div", {
    class: "title_s"
  }, "退货商品", -1)), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.goodsList, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "goods_list",
      key: item
    }, [_createElementVNode("div", {
      class: "goods_img",
      style: _normalizeStyle("background-image: url(" + item.img + ");")
    }, [_createVNode(_component_router_link, {
      to: "/goods/show?id=" + item.id
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
      _: 2
    }, 1032, ["to"])], 4), _createElementVNode("div", _hoisted_4, [_createElementVNode("dl", _hoisted_5, [_createElementVNode("dt", null, _toDisplayString(item.name), 1), _createElementVNode("dd", null, "规格：" + _toDisplayString(item.spec), 1), _createElementVNode("dd", null, "保质期：" + _toDisplayString(item.quality), 1)]), _createElementVNode("dl", _hoisted_6, [_createElementVNode("dt", null, [_createElementVNode("span", null, "￥" + _toDisplayString(item.price) + "/" + _toDisplayString(item.unit), 1), _createTextVNode("X" + _toDisplayString(item.count), 1)]), _createElementVNode("dd", null, "￥" + _toDisplayString(item.total), 1)])])]);
  }), 128))])])], 64);
}